import { registerLocaleData } from '@angular/common';
import localeGermany from '@angular/common/locales/de';
import localeEnGb from '@angular/common/locales/en-GB';
import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '@claas/claas-ui-components/navigation/header';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

registerLocaleData(localeEnGb);
registerLocaleData(localeGermany);

const LANGUAGE_PROVIDERS = [
  { provide: localeEnGb, useValue: 'en-GB' },
  { provide: localeGermany, useValue: 'de' },
];

/** Sprachen, für die Übersetzungsdateien unter `assets/i18n` existieren. */
const SUPPORTED_LANGUAGES = ['de', 'en'];
/** Fallback, wenn weder Aufrufparameter noch Browsersprache unterstützt werden. */
const FALLBACK_LANGUAGE = 'en';

/**
 * Reduziert einen Sprach-Tag auf den unterstützten Basis-Code (z. B. `de-DE` → `de`)
 * und liefert `undefined`, wenn die Sprache nicht unterstützt wird.
 */
function normalizeLanguage(value: string | null | undefined): string | undefined {
  const code = value?.trim().toLowerCase().split('-')[0];
  return code && SUPPORTED_LANGUAGES.includes(code) ? code : undefined;
}

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrls: ['./app.scss'],
  imports: [TranslateModule, HeaderComponent, RouterOutlet],
  providers: [...LANGUAGE_PROVIDERS],
})
export class App {
  private readonly translate = inject(TranslateService);

  constructor() {
    this.translate.use(this.resolveLanguage());
  }

  /**
   * Wählt die Sprache:
   * - Ist der Aufrufparameter `language` **gesetzt**, entscheidet ausschließlich
   *   er – ist er unbekannt oder ohne Übersetzung, wird auf `en` zurückgefallen
   *   (die Browsersprache wird dann bewusst nicht herangezogen).
   * - Fehlt der Parameter, zählt die Browsersprache; ist diese nicht unterstützt,
   *   ebenfalls `en`.
   */
  private resolveLanguage(): string {
    const params = new URLSearchParams(window.location.search);
    if (params.has('language')) {
      return normalizeLanguage(params.get('language')) ?? FALLBACK_LANGUAGE;
    }
    return normalizeLanguage(navigator.language) ?? FALLBACK_LANGUAGE;
  }
}
